module.exports = __webpack_public_path__ + "img/academicBackground_bg2.1c304607.png";